import { docsUseCases as rawDocsUseCases } from './data.js';
import type { SemanticPage } from './types.js';

export const docsUseCases = rawDocsUseCases as SemanticPage[];
